import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => JSON.parse(localStorage.getItem("faunny_cart") || "[]"));
  const [open, setOpen] = useState(false);
  const [settings, setSettings] = useState({ shipping_cost: 4.95, free_shipping_from: 100 });

  useEffect(() => { localStorage.setItem("faunny_cart", JSON.stringify(items)); }, [items]);
  useEffect(() => { api.get("/settings").then((r) => setSettings(r.data)).catch(() => {}); }, []);

  const add = (product, format, qty = 1) => {
    setItems((prev) => {
      const i = prev.findIndex((x) => x.slug === product.slug && x.format_id === format.id);
      if (i >= 0) return prev.map((x, j) => (j === i ? { ...x, qty: Math.min(99, x.qty + qty) } : x));
      return [...prev, { slug: product.slug, name: product.name, format_id: format.id, format_label: format.label,
        price: format.price, image: product.images?.[0] || product.image, qty }];
    });
    toast.success(`${product.name} (${format.label}) añadido al carrito`);
    setOpen(true);
  };
  const setQty = (slug, format_id, qty) =>
    setItems((prev) => prev.map((x) => (x.slug === slug && x.format_id === format_id ? { ...x, qty: Math.max(1, Math.min(99, qty)) } : x)));
  const remove = (slug, format_id) => setItems((prev) => prev.filter((x) => !(x.slug === slug && x.format_id === format_id)));
  const clear = () => setItems([]);

  const subtotal = Math.round(items.reduce((s, x) => s + x.price * x.qty, 0) * 100) / 100;
  const shipping = items.length === 0 || subtotal >= settings.free_shipping_from ? 0 : settings.shipping_cost;
  const tiers = settings.discount_tiers || [];
  const discountPct = Math.max(0, ...tiers.filter((t) => subtotal >= t.min).map((t) => t.pct));
  const discount = Math.round(subtotal * discountPct) / 100;
  const nextTier = tiers.find((t) => subtotal < t.min);
  const count = items.reduce((s, x) => s + x.qty, 0);

  return (
    <CartCtx.Provider value={{ items, add, setQty, remove, clear, subtotal, shipping, discount, discountPct, nextTier, total: subtotal - discount + shipping, count, open, setOpen, settings }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
